export const getAcreedor = (id) => ({
    url: `/blockchain/pagare/acreedor/${id}`,
    method: 'GET',
})